export default __webpack_public_path__ + "img/b256656920f3cc0827a0ea66ad665952.svg";